/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc
 */

export const BooleanFieldValueTypename = 'com.hubspot.chirp.ext.models.BooleanFieldValue';
export const DoubleFieldValueTypename = 'com.hubspot.chirp.ext.models.DoubleFieldValue';
export const FloatFieldValueTypename = 'com.hubspot.chirp.ext.models.FloatFieldValue';
export const IntFieldValueTypename = 'com.hubspot.chirp.ext.models.IntFieldValue';
export const ListFieldValueTypename = 'com.hubspot.chirp.ext.models.ListFieldValue';
export const LongFieldValueTypename = 'com.hubspot.chirp.ext.models.LongFieldValue';
export const MapFieldValueTypename = 'com.hubspot.chirp.ext.models.MapFieldValue';
export const NullFieldValueTypename = 'com.hubspot.chirp.ext.models.NullFieldValue';
export const StringFieldValueTypename = 'com.hubspot.chirp.ext.models.StringFieldValue';
export const getSettingsByIdRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'getSettingsById',
  auth: 'app',
  fingerprint: '4S30eM5qqOIOO1g8-ch1pPd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getSettingsByPathRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'getSettingsByPath',
  auth: 'app',
  fingerprint: 'LnfoBS8FYlQOO1g8-ch1pPd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'list',
  auth: 'app',
  fingerprint: 'UzyQRVHqhh3ugjV9_ZS1WZwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const createRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'create',
  auth: 'app',
  fingerprint: 'xNsgSP1q7EsOO1g8-ch1pJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'update',
  auth: 'app',
  fingerprint: 'K0lIypjBUZcOO1g8-ch1pJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const cloneRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'clone',
  auth: 'app',
  fingerprint: 'UbhY1BLC0eYOO1g8-ch1pJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const hasBufferedChangesRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'hasBufferedChanges',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcT_AMK9WCjTZpwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const getBufferRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'getBuffer',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcQOO1g8-ch1pJwP6LXzGzX8',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const updateBufferRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'updateBuffer',
  auth: 'app',
  fingerprint: 'bkT4g11NQ_8OO1g8-ch1pPd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const pushBufferLiveRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'pushBufferLive',
  auth: 'app',
  fingerprint: 'GrYmmWVVmcQOO1g8-ch1pPd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const restoreVersionToBufferRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'restoreVersionToBuffer',
  auth: 'app',
  fingerprint: '9S7z3DZh93sOO1g8-ch1pPd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listVersionsRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'listVersions',
  auth: 'app',
  fingerprint: 'eQwLn2Q-DzYDHvlOE5BC_Pd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};
export const listVersionsCountedRpc = {
  serviceName: 'com.hubspot.content.themes.modules.rpc.ThemeSettingsRpc',
  rpcName: 'listVersionsCounted',
  auth: 'app',
  fingerprint: 'eQwLn2Q-DzZap-ywZ__bzvd3p3PJOCBD',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false
};